import { AuthMethod } from "../Common/enums";
import { getAppSettings } from "../Common/Utils/localStorageHelper";
import { store } from "../redux/store";


export function buildHttpHeaders(backendHeader: string, contentType: string = 'application/json'): Record<string, string> {
    const state = store.getState();
    const user = state.user;
    const appSettings = getAppSettings();
    const companyId = appSettings.authMethod === AuthMethod.AzureB2C ? appSettings.companyGuid : user?.profile?.company_id ?? '';

    const headers: Record<string, string> = {
        Backend: backendHeader,
        AuthMethod: appSettings.authMethod
    };

    // Add Content-Type only if it's not multipart/form-data
    if (contentType && contentType.toLowerCase() !== 'multipart/form-data') {
        headers['Content-Type'] = contentType;
    }

    if (companyId) {
        headers.CompanyGuid = companyId;
    }

    if (appSettings.handymanApiUrl) {
        headers.HandymanApiUrl = appSettings.handymanApiUrl;
    }

    return headers;
}